import React from 'react';

import './LinkifiedText.css';

const LinkifiedText = ({ children = '', className = '', type }) => {
  const linkify = (children) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    const classNames = ['link-in-text', className].join(' ');

    return children.split(urlRegex).map((part, i) =>
      urlRegex.test(part) ? (
        <a
          key={i}
          href={part}
          target='_blank'
          rel='noopener noreferrer'
          className={classNames}
        >
          {part}
        </a>
      ) : (
        part
      )
    );
  };

  return linkify(children);
};

export default LinkifiedText;
